import Vue from 'vue'
import store from '@/store'
import VueSocketio from 'vue-socket.io'
import io from 'socket.io-client'

const socket = {
	init () {
		if (store.state.connect === false) {
			if (store.state.userAuth !== null) {
				let accessToken = store.state.userAuth.access_token
				Vue.use(VueSocketio, io(store.state.baseURL, {
					transports: ['websocket'],
					upgrade: false,
					query: {
						accessToken: accessToken
					}
				}), store)
				store.commit('SOCKET_CONNECT', true)
			}
		}
	}
}
export default socket



// WEBPACK FOOTER //
// ./src/socket.js